import { i18n } from "../translate/i18n";

export function translate(tag) {
  return i18n.t(tag)
}
